import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {ActivatedRoute, NavigationExtras, Params, Router} from '@angular/router';
import {Select2Option} from '../../../shared/select2-option';
import {ConversionsReferenceDataService} from '../../services/conversions-reference-data.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {DestinationSession} from '../../model/DestinationSession';
import {DocumentSession} from '../../model/DocumentSession';
import {DatePipe, formatDate, Location} from '@angular/common';
import {SelectedSessionDetails} from '../../model/SelectedSessionDetails';
import {ClaimsService} from '../../../shared/claims.service';
import {MessageType} from '../../../shared/messageType';

@Component({
    selector: 're-start-detail-doc-transfer',
    templateUrl: './start-detail-doc-transfer.component.html',
    styleUrls: ['./start-detail-doc-transfer.component.scss'],
    standalone: false
})
export class StartDetailDocTransferComponent implements OnInit {
  destinationForm: UntypedFormGroup;
  closeResult: string;
  private sub: Subscription;
  sourceEnv: string;
  sourceCorp: string;
  sourceFacility: string;
  sourceUnits: string;
  sourceDocTypes: string;
  dateRange: string;
  resCount: number;
  sourceEnvText: string;
  sourceCorpText: string;
  sourceFacText: string;
  destinationEnvironments: Select2Option[];
  destinationCorporations: Select2Option[];
  destinationFacilities: Select2Option[];
  sourceSessionObj: string;
  editSourceEnvironmentDetails: boolean;
  username: String;
  confirmModalDateTime: string;
  confirmModalDestinaionEnvironment: string;
  confirmModalDestinaionCorporation: string;
  confirmModalDestinaionFacility: string;
  redisSessionId: string;


  constructor(private modalService: NgbModal, private selectedSessionDetails: SelectedSessionDetails, private router: Router, private route: ActivatedRoute, private location: Location, private conversionsReferenceDataService: ConversionsReferenceDataService,  private fb: UntypedFormBuilder,  private claimService: ClaimsService,   private datepipe: DatePipe) { }

  ngOnInit() {
    this.username = this.claimService.getPreferredName();
    this.sourceEnv = this.selectedSessionDetails.selectedEnvId;
    this.sourceCorp = this.selectedSessionDetails.selectedCorpId;
    this.sourceFacility = this.selectedSessionDetails.selectedFacId;
    this.sourceUnits = this.selectedSessionDetails.selectedSourceUnitsCount;
    this.sourceDocTypes = this.selectedSessionDetails.selectedSourceDocTypesCount;
    this.dateRange = this.selectedSessionDetails.enteredDateRange;
    this.resCount = this.selectedSessionDetails.selectedResidentCount;
    this.sourceSessionObj = this.selectedSessionDetails.sourceSessionObj;
    this.sourceEnvText =  this.selectedSessionDetails.selectedEnvText;
    this.sourceCorpText = this.selectedSessionDetails.selectedCorpText;
    this.sourceFacText = this.selectedSessionDetails.selectedFacText;
    this.confirmModalDateTime = this.datepipe.transform(new Date(), 'medium');
    this.destinationForm = this.fb.group({
      destinationEnvironment: ['', Validators.required],
      destinationCorporation: ['', Validators.required],
      destinationFacility: ['', Validators.required]
    });

    this.getConversionEnvironments();
  }

/*TODO get metadata from cache instead of calling service again*/
  getConversionEnvironments() {
    this.conversionsReferenceDataService.getConversionEnvironments().subscribe(
      {
        next: x => this.destinationEnvironments = x.map(y => {
          return {id: y.environmentID.toString(), text: y.environmentKey}
        })
      });
  }

  getConversionCorporations() {
    this.resetDropdowns();
    this.conversionsReferenceDataService.getConversionCorporations(this.destinationForm.get('destinationEnvironment').value).subscribe(
      x => this.destinationCorporations = x.map(y => {
        return {id: y.corporationID.toString(), text: y.corpName}
      })
    );
  }

  getConversionFacilities() {
    const destEnvId = this.destinationForm.get('destinationEnvironment').value;
    const destCorporationId = this.destinationForm.get('destinationCorporation').value;
    this.conversionsReferenceDataService.getConversionFacilities(destEnvId, destCorporationId).subscribe(
      x => this.destinationFacilities = x.map(y => {
        return {id: y.facilityID.toString(), text: y.facilityName}
      })
    );
  }

  resetDropdowns() {
    this.destinationCorporations = [];
    this.destinationFacilities = [];
    this.destinationForm.get('destinationCorporation').setValue(null);
    this.destinationForm.get('destinationFacility').setValue(null);
  }


  openModal(modalContent) {
    this.confirmModalDestinaionEnvironment = $('#destinationEnvironment option:selected').text();
    this.confirmModalDestinaionCorporation = $('#destinationCorporation option:selected').text();
    this.confirmModalDestinaionFacility = $('#destinationFacility option:selected').text();

      const options: NgbModalOptions = {
          size: 'lg'
      };
      this.modalService.open(modalContent, options).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return `with: ${reason}`;
      }
  }

  saveSessionDetails() {
    let  documentSession = new DocumentSession();
    let destSession = new DestinationSession();
    destSession.destEnvironmentId = this.destinationForm.get('destinationEnvironment').value;
    destSession.destCorporationId = this.destinationForm.get('destinationCorporation').value;
    destSession.destFacilityId = this.destinationForm.get('destinationFacility').value;
    destSession.destinationEnvironmentName = $('#destinationEnvironment option:selected').text();
    destSession.destinationCorporationName = $('#destinationCorporation option:selected').text();
    destSession.destinationFacilityName = $('#destinationFacility option:selected').text();
    documentSession.sourceSession = JSON.parse(this.sourceSessionObj);
    documentSession.destinationSession = destSession;
    documentSession.movedBy = this.username;
    documentSession.movedDateTime = this.datepipe.transform(new Date(), 'medium');
    /*  formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss a', 'en-US');*/
    documentSession.status = 'IN-Progress';
    this.conversionsReferenceDataService.saveDocumentSession(JSON.stringify(documentSession)).subscribe((sessionId) => {
        this.redisSessionId = sessionId;
    });
  }


  transferDocuments() {
    let  documentSession = new DocumentSession();
    let destSession = new DestinationSession();
    destSession.destEnvironmentId = this.destinationForm.get('destinationEnvironment').value;
    destSession.destCorporationId = this.destinationForm.get('destinationCorporation').value;
    destSession.destFacilityId = this.destinationForm.get('destinationFacility').value;
    destSession.destinationEnvironmentName = $('#destinationEnvironment option:selected').text();
    destSession.destinationCorporationName = $('#destinationCorporation option:selected').text();
    destSession.destinationFacilityName = $('#destinationFacility option:selected').text();
    documentSession.sourceSession = JSON.parse(this.sourceSessionObj);
    documentSession.destinationSession = destSession;
    documentSession.movedBy = this.username;
    documentSession.movedDateTime = this.datepipe.transform(new Date(), 'medium');
    /*  formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss a', 'en-US');*/
    documentSession.status = 'IN-Progress';
    this.conversionsReferenceDataService.transferDocuments(JSON.stringify(documentSession), this.redisSessionId).subscribe();
  }

  removeSessionDetails(key: string) {
    this.conversionsReferenceDataService.removeSessionDetails(key).subscribe();
  }




  goBack(): void {
    this.editSourceEnvironmentDetails = false;
    this.location.back();
  }

  editClicked() {
    this.editSourceEnvironmentDetails = true;
    const navigationExtras: NavigationExtras = {
      queryParams: {'editSourceEnvironmentDetails': this.editSourceEnvironmentDetails },
    };
    this.router.navigate(['/conversions/resident-doc-move/start'], navigationExtras);
  }

}
